import {Libraries, Loader} from '@googlemaps/js-api-loader';
import {env} from '@/config';

const {GOOGLE_MAPS_API_KEY} = env;
const LIBRARIES = ['places'] as Libraries;

let loaderInstance: Loader | null = null;

const getGoogleMapsLoader = () => {
  if (!loaderInstance) {
    loaderInstance = new Loader({
      apiKey: GOOGLE_MAPS_API_KEY,
      version: 'weekly',
      libraries: LIBRARIES
    });
  }
  return loaderInstance;
};

const fetchLocationLabel = async (latitude: number, longitude: number) => {
  try {
    const google = await getGoogleMapsLoader().load();

    const geocoder = new google.maps.Geocoder();

    return new Promise((resolve, reject) => {
      geocoder.geocode(
        {location: {lat: latitude, lng: longitude}},
        (results, status) => {
          if (status === 'OK' && results) {
            if (results[0]) {
              resolve(results[0].formatted_address);
            } else {
              reject('No results found');
            }
          } else {
            reject('Geocoder failed due to: ' + status);
          }
        }
      );
    });
  } catch (error) {
    console.error('Error loading Google Maps libraries:', error);
  }
};

export default fetchLocationLabel;
